import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { useKBTheme } from '../hooks/useKBTheme';
import { useNavigate } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  description: string;
  category: string;
  tags?: string[];
  readTime?: number;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({
  id,
  title,
  description,
  category,
  tags = [],
  readTime = 5,
}) => {
  const { mode } = useKBTheme();
  const navigate = useNavigate();

  return (
    <Card
      onClick={() => navigate(`/knowledge-base/article/${id}`)}
      sx={{
        cursor: 'pointer',
        background: mode === 'dark'
          ? 'rgba(15, 23, 42, 0.6)'
          : 'rgba(255, 255, 255, 0.8)',
        border: mode === 'dark'
          ? '1px solid rgba(71, 85, 105, 0.4)'
          : '1px solid rgba(226, 232, 240, 0.8)',
        borderRadius: 3,
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: mode === 'dark'
            ? '0 12px 32px rgba(0, 0, 0, 0.3)'
            : '0 12px 32px rgba(15, 23, 42, 0.1)',
          borderColor: mode === 'dark'
            ? 'rgba(99, 102, 241, 0.5)'
            : 'rgba(99, 102, 241, 0.4)',
        },
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Chip
            label={category}
            size="small"
            sx={{
              background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
              color: '#fff',
              fontWeight: 600,
              fontSize: '0.7rem',
            }}
          />
          {tags.slice(0, 2).map((tag) => (
            <Chip
              key={tag}
              label={tag}
              size="small"
              sx={{
                background: mode === 'dark'
                  ? 'rgba(71, 85, 105, 0.4)'
                  : 'rgba(241, 245, 249, 0.8)',
                color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b',
                fontSize: '0.7rem',
              }}
            />
          ))}
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mb: 1,
            color: mode === 'dark' ? '#fff' : '#0f172a',
            fontSize: '1.25rem',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Arial, sans-serif',
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : '#64748b',
            lineHeight: 1.7,
            mb: 2,
          }}
        >
          {description}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : '#94a3b8',
            fontSize: '0.75rem',
          }}
        >
          {readTime} min read
        </Typography>
      </CardContent>
    </Card>
  );
};








